// Turn is a JavaScript library that adds transitions with Turbo Drive.
// https://github.com/domchristie/turn

import Turn from '@domchristie/turn/dist/turn.js'

Turn.start()
